import { getTokenCookie } from './cookies';
import axiosInstance from 'axios';
import * as Sentry from '@sentry/react';

const axios = axiosInstance.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

axios.interceptors.request.use(
  config => {
    // Get token from cookie instead of localStorage
    const token = getTokenCookie();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Optional: Response interceptor for handling expired tokens
axios.interceptors.response.use(
  response => response,
  error => {
    // Capture API errors to Sentry (only in non-development mode)
    if (!import.meta.env.DEV) {
      if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        const url = error.config?.url || 'unknown';
        const method = error.config?.method?.toUpperCase() || 'unknown';

        // Don't capture 401 errors (authentication issues are expected)
        if (status !== 401) {
          Sentry.captureException(error, {
            tags: {
              api_error: true,
              status_code: status,
              method,
              url,
            },
            contexts: {
              response: {
                status,
                statusText: error.response.statusText,
                data: error.response.data,
              },
              request: {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers,
              },
            },
          });
        }
      } else if (error.request) {
        // Request was made but no response received
        Sentry.captureException(error, {
          tags: {
            api_error: true,
            network_error: true,
          },
          contexts: {
            request: {
              url: error.config?.url,
              method: error.config?.method,
            },
          },
        });
      } else {
        // Something else happened
        Sentry.captureException(error, {
          tags: {
            api_error: true,
          },
        });
      }
    }

    if (error.response?.status === 401) {
      // Token expired or unauthorized
      // eslint-disable-next-line no-console
      console.error('Unauthorized, redirecting to login...');
      // window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axios;
